import { BaseService } from "./base.service";
import { assert } from "@/core";
export class UniversityTemplateService extends BaseService {
  constructor() {
    super("university-templates");
  }

  async getListUniTemplateCriteriaByUniId(id = window.required()) {
    assert.id(id, { required: true });

    const response = await this.request({ auth: true }).get(
      `${this.entity}/${id}/criteria`,
      {}
    );
    return response.data;
  }
}
